const SERVICE_PATHS = new Set([
  "/staff-augmentation",
  "/software-app-development",
  "/partners",
  "/dedicated-engineering-squads",
  "/devops-sre",
  "/ai-engineers",
  "/contact-center",
  "/case-studies",
  "/nearshore-software-development",
  "/fintech-engineering",
  "/cpaas-engineering",
  "/accounting-automation-engineering",
  "/accounting-software-development",
]);

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function normalizePathname(pathname) {
  if (!pathname) return "/";
  if (pathname.length > 1 && pathname.endsWith("/")) return pathname.slice(0, -1);
  return pathname;
}

function stripLocalePrefix(pathname) {
  const p = normalizePathname(pathname);
  const parts = p.split("/").filter(Boolean);
  if (parts.length === 0) return "/";
  const maybeLocale = parts[0];
  if (maybeLocale && maybeLocale.length === 2) {
    return `/${parts.slice(1).join("/")}` || "/";
  }
  return p;
}

export function inferServiceFromPathname(pathname) {
  const p = stripLocalePrefix(pathname);
  const parts = normalizePathname(p).split("/").filter(Boolean);
  if (parts.length === 0) return undefined;
  return parts[0];
}

export function isServicePathname(pathname) {
  const p = stripLocalePrefix(pathname);
  return SERVICE_PATHS.has(normalizePathname(p));
}

export function trackEvent(name, params) {
  if (!isBrowser()) return false;
  const gtag = window.gtag;
  if (typeof gtag !== "function") return false;

  try {
    gtag("event", name, params || {});
    return true;
  } catch (_e) {
    return false;
  }
}

export function trackCtaClick({ cta_location, cta_text, target_url, service, page_path }) {
  return trackEvent("cta_click", {
    cta_location,
    cta_text,
    target_url,
    service,
    page_path,
  });
}

export function trackServicePageView({ service, page_path }) {
  return trackEvent("service_page_view", { service, page_path });
}

export function trackEmailClick({ target_url, page_path, service }) {
  return trackEvent("email_click", { target_url, page_path, service });
}

export function trackLinkedinClick({ target_url, page_path, service }) {
  return trackEvent("linkedin_click", { target_url, page_path, service });
}

export function trackBookCallClick({ target_url, page_path, service }) {
  return trackEvent("book_call_click", { target_url, page_path, service });
}

export function trackContactFormSubmit({ page_path, service }) {
  return trackEvent("contact_form_submit", { page_path, service });
}

export function trackRequestSeniorSquadClick({ cta_location, page_path }) {
  return trackEvent("request_senior_squad_click", { cta_location, page_path });
}

export function trackSeeHowItWorksClick({ cta_location, page_path }) {
  return trackEvent("see_how_it_works_click", { cta_location, page_path });
}

export function trackCaseStudyClick({ case_study, target_url, page_path }) {
  return trackEvent("case_study_click", { case_study, target_url, page_path });
}

export function trackDevOpsSreCtaClick({ cta_location, page_path }) {
  return trackEvent("devops_sre_cta_click", { cta_location, page_path });
}

export function trackAiEngineersCtaClick({ cta_location, page_path }) {
  return trackEvent("ai_engineers_cta_click", { cta_location, page_path });
}

export function trackZapierPartnerCtaClick({ cta_location, page_path }) {
  return trackEvent("zapier_partner_cta_click", { cta_location, page_path });
}

export function trackFinalCtaClick({ cta_location, page_path }) {
  return trackEvent("final_cta_click", { cta_location, page_path });
}

export function trackLeadFormSubmit({ page_path }) {
  return trackEvent("lead_form_submit", { page_path });
}

export function trackCalendarEmbedLoaded({ page_path }) {
  return trackEvent("calendar_embed_loaded", { page_path });
}

export function trackCalendarBookingCompleted({ page_path }) {
  return trackEvent("calendar_booking_completed", { page_path });
}

export function trackClutchClick({ target_url, page_path }) {
  return trackEvent("clutch_click", { target_url, page_path });
}

export function trackPartnerBadgeClick({ partner, target_url, page_path }) {
  return trackEvent("partner_badge_click", { partner, target_url, page_path });
}
